export const PRODUCT_PLACEHOLDER_URL = 'https://valleyapi-dr9y.onrender.com/data/placeholder.jpg';

const API_BASE = 'https://valleyapi-dr9y.onrender.com';

export const getProductImageUrl = (value) => {
  const image = String(value || '').trim();
  const normalizedImage = image.toLowerCase();

  if (!image || ['none', 'null', 'undefined', 'n/a', 'na'].includes(normalizedImage)) {
    return PRODUCT_PLACEHOLDER_URL;
  }

  if (/^https?:\/\//i.test(image)) return image;
  if (image.startsWith('/data/')) return `${API_BASE}${image}`;
  if (image.startsWith('data/')) return `${API_BASE}/${image}`;

  return `${API_BASE}/data/${image.replace(/^\/+/, '')}`;
};

export const useProductImageFallback = (event) => {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = PRODUCT_PLACEHOLDER_URL;
};
